// Weeks Honey Farm Shopify theme — theme.js
// Built by Revive OS
(function () {
  'use strict';

  // ============================================================
  // Helpers
  // ============================================================
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const money = (cents) => {
    const format = window.Shopify && Shopify.money_format ? Shopify.money_format : '${{amount}}';
    const val = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, val);
  };

  // ============================================================
  // Header scroll
  // ============================================================
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 50);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ============================================================
  // Cart drawer
  // ============================================================
  const cartDrawer = $('[data-cart-drawer]');
  const cartOverlay = $('[data-cart-overlay]');
  let cartLastFocus = null;
  const openCart = () => {
    if (!cartDrawer) return;
    cartLastFocus = document.activeElement;
    cartDrawer.classList.add('open');
    cartOverlay?.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
    // Focus trap: focus first focusable inside drawer
    requestAnimationFrame(() => {
      // whf-fix-20260608: focus the Checkout CTA when present so it's immediately discoverable
      // after add-to-cart; fall back to the first focusable element (e.g. empty cart).
      const target = cartDrawer.querySelector('.cart-checkout-btn') || cartDrawer.querySelector('button, a, input, [tabindex]:not([tabindex="-1"])');
      target?.focus();
    });
  };
  const closeCart = () => {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    cartDrawer?.setAttribute('inert', '');
    document.body.style.overflow = '';
    cartLastFocus?.focus?.();
  };
  // Focus trap — Tab inside drawer cycles through drawer only
  cartDrawer?.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !cartDrawer.classList.contains('open')) return;
    const focusable = cartDrawer.querySelectorAll('button, a, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  if (cartDrawer && !cartDrawer.classList.contains('open')) {
    cartDrawer.setAttribute('inert', '');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }
  $$('[data-cart-toggle]').forEach(el => el.addEventListener('click', openCart));
  $$('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  cartOverlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); closeMobileMenu(); } });

  // ============================================================
  // Mobile menu drawer
  // ============================================================
  const mobileDrawer = $('[data-mobile-menu-drawer]');
  const mobileOverlay = $('[data-mobile-menu-overlay]');
  let mobileLastFocus = null;
  const openMobileMenu = () => {
    if (!mobileDrawer) return;
    mobileLastFocus = document.activeElement;
    mobileDrawer.classList.add('open');
    mobileDrawer.style.transform = 'translateX(0)';
    mobileDrawer.setAttribute('aria-hidden', 'false');
    mobileDrawer.removeAttribute('inert');
    mobileOverlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => {
      const first = mobileDrawer.querySelector('button, a, input, [tabindex]:not([tabindex="-1"])');
      first?.focus();
    });
  };
  const closeMobileMenu = () => {
    if (!mobileDrawer) return;
    mobileDrawer.classList.remove('open');
    mobileDrawer.style.transform = 'translateX(-100%)';
    mobileDrawer.setAttribute('aria-hidden', 'true');
    mobileDrawer.setAttribute('inert', '');
    mobileOverlay?.classList.remove('open');
    document.body.style.overflow = '';
    mobileLastFocus?.focus?.();
  };
  mobileDrawer?.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || !mobileDrawer.classList.contains('open')) return;
    const focusable = mobileDrawer.querySelectorAll('button, a, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  // Initialize inert state on load
  if (mobileDrawer && mobileDrawer.getAttribute('aria-hidden') === 'true') {
    mobileDrawer.setAttribute('inert', '');
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileDrawer?.classList.contains('open')) closeMobileMenu();
  });
  $$('[data-mobile-menu-toggle]').forEach(el => el.addEventListener('click', openMobileMenu));
  $$('[data-mobile-menu-close]').forEach(el => el.addEventListener('click', closeMobileMenu));
  mobileOverlay?.addEventListener('click', closeMobileMenu);

  // ============================================================
  // Cart API
  // ============================================================
  async function updateCart(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates }),
    });
    return res.json();
  }

  async function fetchCartHtml() {
    const res = await fetch('/?sections=header,cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    return res.json().catch(() => null);
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      // Update counts everywhere
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
      // Re-render drawer inner HTML by reloading the page partial
      const drawerHtml = await fetch(window.location.pathname + '?section_id=__legacy_refresh').catch(() => null);
      if (!drawerHtml) location.reload();
    } catch (e) {
      console.error('refreshCartDrawer', e);
    }
  }

  // Rerender cart drawer from Shopify Section Rendering API (no page reload)
  window.whfRerenderCartDrawer = rerenderCartDrawer;
  window.whfOpenCart = openCart;
  async function rerenderCartDrawer() {
    try {
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
      // Pull the footer section (which includes cart drawer via layout — but drawer is in layout, so refetch whole page)
      const html = await fetch(window.location.pathname + '?_cb=' + Date.now(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } }).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      // whf-fix-20260608 (WO f99ee667): replace the ENTIRE drawer inner (header + free-ship bar +
      // body + footer) in one shot. The footer (Checkout button + View cart + subtotal) and the
      // shipping bar are wrapped in {% if cart.item_count > 0 %}, so the old per-node innerHTML swap
      // never INSERTED them when adding the FIRST item to an empty cart (curFooter was null) — the
      // shopper saw a cart with items but no Checkout button until a full page reload. This is the
      // "couldn't find Checkout / purchase not completed" report.
      const newAside = doc.querySelector('[data-cart-drawer]');
      const curAside = document.querySelector('[data-cart-drawer]');
      if (newAside && curAside) {
        curAside.innerHTML = newAside.innerHTML;
        // close button lives inside the replaced markup — rebind it (qty +/- are document-delegated).
        curAside.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
      }
    } catch (e) { console.error('rerenderCartDrawer', e); }
  }

  // Quantity adjusters in drawer
  document.addEventListener('click', async (e) => {
    const item = e.target.closest('[data-cart-item]');
    if (!item) return;
    const variantId = item.dataset.variantId;
    const currentQty = parseInt(item.querySelector('.cart-item-qty-value')?.textContent || '1', 10);
    if (e.target.matches('[data-qty-increase]')) {
      await updateCart({ [variantId]: currentQty + 1 });
      await rerenderCartDrawer();
    } else if (e.target.matches('[data-qty-decrease]')) {
      await updateCart({ [variantId]: Math.max(0, currentQty - 1) });
      await rerenderCartDrawer();
    }
  });

  // whf-fix-20260908d (wrong-flavour-in-cart, part 3). Intercepting the Add-to-Cart CLICK stops Fast
  // Bundle (Rapi) most of the time, but not always: verified live 2026-09-08, if the shopper touches
  // the quantity stepper first, Rapi still fires its own /cart/add and the cart came back as
  // "Reishi Mushroom x3 + Golden Turmeric x1". Rapi reacts to more than the click, so blocking one
  // event is not enough — block the REQUEST instead, which is the thing that actually does damage.
  //
  // Scope is deliberately narrow: only a /cart/add whose body carries BOTH `_rapi_bundles` AND an
  // `items` collection, i.e. the app's own multi-line add built from a hardcoded variant id. The
  // theme's own add is `{"id":...,"quantity":...}` — it carries _rapi_bundles (so the tier discount
  // still applies) but never `items`, so it is never matched. A blocked call is answered with an
  // empty success so the app's own UI doesn't error-loop.
  (function blockStaleAppCartAdds() {
    const isStaleAppAdd = (url, body) =>
      typeof url === 'string' && /\/cart\/add/.test(url) &&
      typeof body === 'string' && body.indexOf('_rapi_bundles') !== -1 && /items(\[|%5B|")/.test(body) &&
      // whf-fix-20261008 (Revive): the Build-Your-Own box builder also posts items[] + _rapi_bundles, but with
      // the shopper's own picks and a _rapi_box_builder tag. The 20260908d guard was swallowing it with a fake
      // success, so no box could reach the cart for a month. Only the PDP bundle widget is blocked now.
      body.indexOf('_rapi_box_builder') === -1;

    const nativeOpen = XMLHttpRequest.prototype.open;
    const nativeSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__whfMethod = method; this.__whfUrl = url;
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (String(this.__whfMethod).toUpperCase() === 'POST' && isStaleAppAdd(this.__whfUrl, body)) {
        console.warn('WHF: blocked a bundle-app cart add using a stale variant id');
        const xhr = this;
        setTimeout(function () {
          try {
            Object.defineProperty(xhr, 'readyState', { value: 4, configurable: true });
            Object.defineProperty(xhr, 'status', { value: 200, configurable: true });
            Object.defineProperty(xhr, 'responseText', { value: '{"items":[]}', configurable: true });
            Object.defineProperty(xhr, 'response', { value: '{"items":[]}', configurable: true });
            if (typeof xhr.onreadystatechange === 'function') xhr.onreadystatechange();
            xhr.dispatchEvent(new Event('readystatechange'));
            xhr.dispatchEvent(new Event('load'));
            xhr.dispatchEvent(new Event('loadend'));
          } catch (err) { console.warn('WHF: stub response failed', err); }
        }, 0);
        return;
      }
      return nativeSend.apply(this, arguments);
    };

    const nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const body = init && typeof init.body === 'string' ? init.body : '';
      if (isStaleAppAdd(url, body)) {
        console.warn('WHF: blocked a bundle-app cart add using a stale variant id (fetch)');
        return Promise.resolve(new Response('{"items":[]}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
      }
      return nativeFetch.apply(this, arguments);
    };
  })();

  // Add to cart (product form)
  const productForm = $('[data-product-form]');
  if (productForm) {
    // whf-fix-20260908b (wrong-flavour-in-cart, part 2). Fast Bundle (Rapi) binds its OWN click
    // handler to the Add-to-Cart button and posts its own /cart/add for the extra units of a
    // "Buy 3+ / Buy 6+" tier — with a HARDCODED variant id. Verified live 2026-09-08: it sends the
    // product's FIRST variant (Reishi Mushroom) even on a clean server-rendered ?variant=<other>
    // load, so it is not reading the shopper's choice at all and no amount of theme-side variant
    // syncing can correct it. Picking "Dark Cocoa" produced a cart of Dark Cocoa x1 + Reishi x2.
    //
    // So the theme owns the whole add now: intercept the click in the CAPTURE phase (before any app
    // handler runs), read the quantity the shopper can actually see (Rapi rewrites [name="quantity"]
    // to 1 inside its own handler), and post ONE /cart/add with the right variant and the full
    // quantity. The Rapi bundle properties still ride along, so the tier discount still applies —
    // confirmed live: a theme-posted line carrying _rapi_bundles priced at $8.99, not $9.99.
    let atcInFlight = false;

    async function addCurrentSelectionToCart(quantityOverride) {
      if (atcInFlight) return;
      atcInFlight = true;
      const btn = productForm.querySelector('[data-atc-btn]');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      try {
        // whf-fix-20260908 (wrong-variant-in-cart): post an explicit {id, quantity} resolved from
        // the shopper's own radio selection. Posting `new FormData(productForm)` shipped whatever
        // [name="id"] / [name="quantity"] an app had last written into the form — Fast Bundle (Rapi)
        // rewrites both on Add-to-Cart, which is how "Dark Cocoa" ended up adding "Reishi Mushroom".
        // App-owned properties[...] / selling_plan are carried through so bundles + Subscribe & Save
        // still apply.
        const variantId = currentVariantId();
        if (!variantId) throw new Error('No variant selected');
        const qtyEl = productForm.querySelector('[data-qty-input]') || document.querySelector('[data-qty-input]');
        const quantity = quantityOverride || Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        const properties = {};
        $$('[name^="properties["]', productForm).forEach(el => {
          if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
          const key = el.name.slice(11, -1);
          if (key && el.value !== '') properties[key] = el.value;
        });
        // The Subscriptions app block renders one <section data-variant-id> per variant and they all
        // live in this form, so scope the selling plan to the variant actually being bought.
        const planEl = $$('input[name="selling_plan"]:checked, select[name="selling_plan"]', productForm)
          .filter(el => el.value)
          .find(el => {
            const scope = el.closest('[data-variant-id]');
            return !scope || String(scope.dataset.variantId) === String(variantId);
          });
        const payload = { id: variantId, quantity };
        if (Object.keys(properties).length) payload.properties = properties;
        if (planEl) payload.selling_plan = planEl.value;
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await addCheckedCrossSells();
        if (btn) {
          btn.textContent = '✓ Added!';
          setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 1500);
        }
        await rerenderCartDrawer();
        openCart();
      } catch (err) {
        console.error(err);
        if (btn) {
          btn.textContent = 'Error — try again';
          setTimeout(() => { btn.textContent = originalText; btn.disabled = false; }, 2000);
        }
      } finally {
        setTimeout(() => { atcInFlight = false; }, 800);
      }
    }

    // Rapi's "You might also like" cross-sell rides on the click handler we now intercept, so honour
    // any toggle the shopper switched on. Only ever adds a variant id we can actually resolve from
    // the widget — never a guess.
    async function addCheckedCrossSells() {
      const toggles = $$('input[type="checkbox"][class*="rapi-toggle"]:checked, input[type="checkbox"][id^="add_cross_sell"]:checked');
      for (const toggle of toggles) {
        const row = toggle.closest('[class*="cross-sell"], [class*="rapi-cross"]') || toggle.parentElement;
        if (!row) continue;
        let id = null;
        const sel = row.querySelector('select');
        if (sel && /^\d{10,}$/.test(sel.value)) id = sel.value;
        if (!id) {
          const node = row.querySelector('[data-variant-id]');
          if (node && /^\d{10,}$/.test(node.dataset.variantId)) id = node.dataset.variantId;
        }
        if (!id) { console.warn('cross-sell toggle on but no resolvable variant — skipped'); continue; }
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id, quantity: 1 }),
        }).catch(err => console.warn('cross-sell add failed', err));
      }
    }

    // Capture phase on document: runs before Rapi's own click listener on the button.
    document.addEventListener('click', (e) => {
      const btn = e.target.closest && e.target.closest('[data-atc-btn]');
      if (!btn || !productForm.contains(btn) || btn.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addCurrentSelectionToCart();
    }, true);

    // The sticky mobile bar calls form.requestSubmit() rather than clicking the button.
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      addCurrentSelectionToCart();
    });

    // Variant option click handler
    $$('[data-variant-options]', productForm).forEach(group => {
      group.addEventListener('click', (e) => {
        const label = e.target.closest('label.variant-option');
        if (!label) return;
        group.querySelectorAll('label.variant-option').forEach(l => l.classList.remove('selected'));
        label.classList.add('selected');
        // Sync hidden select with full option combination
        updateVariantSelection();
      });
    });

    // whf-fix-20260908 (wrong-variant-in-cart). Two bugs lived in the old resolver:
    //   1. It matched a variant by substring — `optionLabel.includes(selectedValue)` — so any option
    //      value that is a substring of another ("S" inside "XS", "Ceylon Cinnamon (16 oz)" inside
    //      "(32 oz)") resolved to whichever variant came first. Now matched on the exact
    //      data-o1/o2/o3 values rendered by main-product.liquid.
    //   2. It only ASSIGNED select.value. A programmatic assignment fires no `change` event, so every
    //      app that tracks the chosen variant (Fast Bundle/Rapi, Shopify Subscriptions, Judge.me,
    //      pixels) stayed pinned to the variant that was current at page load — and Rapi then wrote
    //      that stale id straight back into this form's [name="id"] on Add-to-Cart. Picking
    //      "Dark Cocoa" put "Reishi Mushroom" in the cart. Now we fire `change` on the select, a
    //      window `variantUpdated` event (Rapi's own documented hook) and keep ?variant= in the URL
    //      the way a stock Shopify theme does.
    function selectedOptionValues() {
      return $$('[data-variant-options]', productForm).map(group => {
        const checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      }).filter(v => v !== null);
    }

    function matchVariantOption(values) {
      const select = productForm.querySelector('[data-variant-select]');
      if (!select) return null;
      if (!values.length) return select.options[select.selectedIndex] || select.options[0] || null;
      for (const opt of select.options) {
        const exact = [opt.dataset.o1, opt.dataset.o2, opt.dataset.o3];
        const hasExact = exact.some(v => v !== undefined && v !== '');
        // data-o* is authoritative; the text fallback only runs against an older cached render.
        const ok = hasExact
          ? values.every((v, i) => exact[i] === v)
          : values.every(v => opt.text.includes(v));
        if (ok) return opt;
      }
      return null;
    }

    function currentVariantId() {
      const opt = matchVariantOption(selectedOptionValues());
      if (opt) return opt.value;
      const select = productForm.querySelector('[data-variant-select]');
      return select ? select.value : null;
    }

    // Broadcast the shopper's pick to the rest of the page. Best-effort: never let a listener or a
    // blocked history write break the picker.
    async function announceVariant(variantId) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      } catch (err) {
        console.warn('announceVariant history', err);
      }
      let detail = { id: Number(variantId) || variantId };
      try {
        const data = await getProductData();
        const v = (data.variants || []).find(x => String(x.id) === String(variantId));
        if (v) detail = v;
      } catch (err) {
        console.warn('announceVariant product data', err);
      }
      try {
        window.dispatchEvent(new CustomEvent('variantUpdated', { detail }));
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: detail }, bubbles: true }));
      } catch (err) {
        console.warn('announceVariant dispatch', err);
      }
    }

    // whf-fix-20260908c: the option chips gave no hint that a combination is sold out — every chip
    // looked buyable and the shopper only found out after clicking it (the ATC button then reads
    // "Sold out"). On the Farmer & His Bees tee the whole Citron colourway is gone, and 24 variants
    // across the catalogue are in that state. Grey out any value with no available variant given the
    // other chosen options, the way a stock Shopify theme does. Chips stay clickable so a shopper can
    // still inspect the price.
    async function refreshOptionAvailability() {
      let data;
      try { data = await getProductData(); } catch (err) { console.warn('option availability', err); return; }
      if (!data || !data.variants) return;
      const chosen = selectedOptionValues();
      $$('[data-variant-options]', productForm).forEach((group, idx) => {
        group.querySelectorAll('label.variant-option').forEach(label => {
          const input = label.querySelector('input[type="radio"]');
          if (!input) return;
          const probe = chosen.slice();
          probe[idx] = input.value;
          const ok = data.variants.some(v => v.available && probe.every((val, i) => val == null || v.options[i] === val));
          // theme.css already ships `.variant-option.sold-out` (dimmed + struck through); nothing
          // had ever applied it until now.
          label.classList.toggle('sold-out', !ok);
          label.setAttribute('aria-disabled', String(!ok));
        });
      });
    }

    function updateVariantSelection() {
      const select = productForm.querySelector('[data-variant-select]');
      if (!select) return;
      const opt = matchVariantOption(selectedOptionValues());
      if (opt) {
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        refreshVariantDisplay(opt.value);
        announceVariant(opt.value);
        refreshOptionAvailability();
      }
      // Also update each "Selected value:" strong text
      $$('[data-variant-options]', productForm).forEach((group, idx) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        const label = productForm.querySelector('[data-selected-' + idx + ']');
        if (label && checked) label.textContent = checked.value;
      });
    }

    // whf-fix-20260608: net product weight (oz) parsed from a labeled title like "16 Ounce",
    // "1 lb Beeswax Bar", or "1 oz (6 Pack) Beeswax". Preferred over variant.weight for $/oz
    // because glass-jar honey ships heavier than its net contents (jar weight). Returns 0 if none.
    function netOzFromTitle(t) {
      if (!t) return 0;
      t = String(t).toLowerCase();
      let pack = 1;
      const pm = t.match(/(\d+)\s*[- ]?pack/);
      if (pm) pack = parseInt(pm[1], 10) || 1;
      const m = t.match(/(\d+(?:\.\d+)?)\s*(ounces?|oz|pounds?|lbs?|#|kilograms?|kg|grams?|g)\b/);
      if (!m) return 0;
      const n = parseFloat(m[1]); const u = m[2];
      let oz = 0;
      if (/^(oz|ounce)/.test(u)) oz = n;
      else if (/^(lb|pound|#)/.test(u)) oz = n * 16;
      else if (/^(kg|kilogram)/.test(u)) oz = n * 35.27396;
      else if (/^(g|gram)/.test(u)) oz = n / 28.349523;
      return oz * pack;
    }
    // whf-fix-20260608: cache the product .js so we fetch once per PDP, not per variant click.
    let _productData = null;
    async function getProductData() {
      if (_productData) return _productData;
      const res = await fetch(window.location.pathname + '.js');
      _productData = await res.json();
      return _productData;
    }
    async function refreshVariantDisplay(variantId, skipImage) {
      try {
        const data = await getProductData();
        const variant = (data.variants || []).find(v => String(v.id) === String(variantId));
        if (!variant) return;
        const format = (cents) => '$' + (cents / 100).toFixed(2);
        const priceEl = document.querySelector('[data-price]');
        // whf-fix-20260608: compare span uses data-was-price (NOT data-compare-price) because Fast
        // Bundle (Rapi) auto-targets [data-compare-price] and overwrites it with the bundle-tier total.
        const compareEl = document.querySelector('[data-was-price]');
        const badgeEl = document.querySelector('[data-save-badge]');
        const atcPriceEl = document.querySelector('[data-atc-price]');
        const atcBtn = productForm.querySelector('[data-atc-btn]');
        if (priceEl) priceEl.textContent = format(variant.price);
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (compareEl) {
          if (onSale) {
            compareEl.textContent = format(variant.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (badgeEl) {
          if (onSale) {
            badgeEl.textContent = 'Save ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
            badgeEl.style.display = '';
          } else {
            badgeEl.style.display = 'none';
          }
        }
        if (atcPriceEl) atcPriceEl.textContent = format(variant.price);
        if (atcBtn) {
          atcBtn.disabled = !variant.available;
          atcBtn.textContent = variant.available ? 'Add to Cart — ' + format(variant.price) : 'Sold out';
        }
        // whf-fix-20260608: price-per-ounce. Element only exists in DOM for weight-sold goods
        // (honey/beeswax — see _per_oz_ok gate in main-product.liquid). variant.grams is always grams.
        const perOzEl = document.querySelector('[data-price-per-oz]');
        if (perOzEl) {
          // Prefer labeled net size (variant title, then product title); fall back to shipping weight.
          const netOz = netOzFromTitle(variant.title) || netOzFromTitle(data.title) || ((variant.weight || 0) / 28.349523);
          perOzEl.textContent = netOz > 0 ? '$' + ((variant.price / 100) / netOz).toFixed(2) + '/oz' : '';
        }
        // whf-fix-20260608: swap the main gallery image to the selected variant's image.
        // whf-fix-20260610: skip on initial load (skipImage=true) so the product's hero/featured
        // photo shows first; only swap once the shopper actively selects a size.
        const vImg = skipImage ? null : variant.featured_image;
        if (vImg && vImg.src) {
          const mainImg = document.querySelector('#gallery-main-img, #gallery-main img, .product-gallery-main img');
          if (mainImg) {
            mainImg.src = vImg.src.startsWith('//') ? 'https:' + vImg.src : vImg.src;
            mainImg.srcset = ''; // clear old srcset so new src wins
            if (vImg.alt) mainImg.alt = vImg.alt;
          }
          const fname = u => (u || '').split('?')[0].split('/').pop();
          const vf = fname(vImg.src);
          $$('[data-gallery-thumb]').forEach(t => t.classList.toggle('active', fname(t.dataset.img) === vf));
        }
      } catch (e) { console.error('refreshVariantDisplay', e); }
    }

    // whf-fix-20260608: initial sync — populate per-oz (and assert unit price + variant image)
    // for the pre-selected variant on load, without waiting for a click.
    (function initVariantDisplay() {
      const sel = productForm.querySelector('[data-variant-select]');
      if (sel && sel.value) refreshVariantDisplay(sel.value, true); // skipImage: keep the hero photo on load
      refreshOptionAvailability();
    })();

    // Quantity picker
    const qtyInput = $('[data-qty-input]', productForm);
    $('[data-qty-increase]', productForm)?.addEventListener('click', () => qtyInput.value = parseInt(qtyInput.value) + 1);
    $('[data-qty-decrease]', productForm)?.addEventListener('click', () => qtyInput.value = Math.max(1, parseInt(qtyInput.value) - 1));
  }

  // ============================================================
  // Product gallery thumbnails
  // ============================================================
  $$('[data-gallery-thumb]').forEach(btn => {
    btn.addEventListener('click', () => {
      const img = btn.dataset.img;
      const main = document.querySelector('#gallery-main img, #gallery-main-img, .product-gallery-main img, [data-gallery-main]');
      if (main && img) {
        // Normalize protocol-relative URLs
        main.src = img.startsWith('//') ? 'https:' + img : img;
        main.srcset = ''; // clear old srcset so new src wins
      }
      $$('[data-gallery-thumb]').forEach(t => t.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // ============================================================
  // Mobile product carousels — arrow nav (WO f99ee667)
  // Home featured-collection rows scroll-snap horizontally on mobile.
  // Add prev/next arrows + hide them at the track edges.
  // ============================================================
  $$('[data-carousel]').forEach(wrap => {
    const track = wrap.querySelector('[data-carousel-track]');
    const prev = wrap.querySelector('[data-carousel-prev]');
    const next = wrap.querySelector('[data-carousel-next]');
    if (!track) return;
    const cards = () => [...track.querySelectorAll('.product-card')];
    // index of the card currently snapped nearest the track's left edge
    const currentIndex = () => {
      const cs = cards(); const trackLeft = track.getBoundingClientRect().left;
      let idx = 0, best = Infinity;
      cs.forEach((c, i) => { const d = Math.abs(c.getBoundingClientRect().left - trackLeft); if (d < best) { best = d; idx = i; } });
      return idx;
    };
    // Manual rAF tween: native scrollBy({behavior:'smooth'}) is cancelled by
    // scroll-snap-type:mandatory (the snap re-pins the scroll every frame, so the arrow does
    // nothing). We disable snap for the duration, animate scrollLeft to the exact card edge, then
    // restore snap (which holds, since we land precisely on a snap point).
    const updateArrows = () => {
      // rest scrollLeft sits ~16px in from the track's 1rem padding + scroll-snap, so use a
      // generous threshold for the start/end edges.
      const atStart = track.scrollLeft <= 24;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 24;
      if (prev) prev.hidden = atStart;
      if (next) next.hidden = atEnd;
    };
    let rafId = null;
    const goToCard = (idx) => {
      const cs = cards(); if (!cs.length) return;
      idx = Math.max(0, Math.min(cs.length - 1, idx));
      const from = track.scrollLeft;
      const delta = cs[idx].getBoundingClientRect().left - track.getBoundingClientRect().left;
      if (Math.abs(delta) < 1) return;
      if (rafId) cancelAnimationFrame(rafId);  // cancel any in-flight tween
      track.style.scrollSnapType = 'none';     // snap:mandatory cancels programmatic smooth scroll
      const t0 = (window.performance || Date).now();
      const frame = (now) => {
        const p = Math.min(1, (now - t0) / 350);
        track.scrollLeft = from + delta * (1 - Math.pow(1 - p, 3)); // easeOutCubic
        if (p < 1) { rafId = requestAnimationFrame(frame); }
        else { rafId = null; track.style.scrollSnapType = ''; updateArrows(); } // restore CSS snap + sync arrows
      };
      rafId = requestAnimationFrame(frame);
    };
    prev?.addEventListener('click', () => goToCard(currentIndex() - 1));
    next?.addEventListener('click', () => goToCard(currentIndex() + 1));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });

  // ============================================================
  // Search toggle
  // ============================================================
  $('[data-search-toggle]')?.addEventListener('click', () => {
    const q = prompt('Search for...');
    if (q) window.location.href = `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(q)}`;
  });

  // ============================================================
  // Scroll-reveal fade-ups (progressive enhancement — no-JS shows all)
  // ============================================================
  (function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    // Only target items below the fold — items in initial viewport should just show
    const belowFold = Array.from(document.querySelectorAll('.section-header, .feature-grid > *, .product-grid > *, .seasonal-grid > *'))
      .filter(el => el.getBoundingClientRect().top > window.innerHeight * 0.85);
    belowFold.forEach(el => el.classList.add('reveal'));
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    belowFold.forEach(el => io.observe(el));
  })();

  // ============================================================
  // Product gallery zoom pan (desktop)
  // ============================================================
  (function initZoom() {
    const wrap = document.querySelector('.product-gallery-main');
    const img = wrap?.querySelector('img');
    if (!wrap || !img || window.innerWidth < 1024) return;
    wrap.addEventListener('mousemove', e => {
      const r = wrap.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
    });
    wrap.addEventListener('mouseleave', () => { img.style.transformOrigin = 'center center'; });
  })();

  // ============================================================
  // Wishlist (localStorage-backed)
  // ============================================================
  window.toggleWishlist = function(handle, btn) {
    const key = 'whf_wishlist';
    const list = JSON.parse(localStorage.getItem(key) || '[]');
    const i = list.indexOf(handle);
    if (i >= 0) { list.splice(i, 1); btn.classList.remove('saved'); }
    else { list.push(handle); btn.classList.add('saved'); }
    localStorage.setItem(key, JSON.stringify(list));
    refreshWishlistBadges();
  };
  function refreshWishlistBadges() {
    const list = JSON.parse(localStorage.getItem('whf_wishlist') || '[]');
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const card = btn.closest('.product-card');
      if (!card) return;
      const href = card.getAttribute('href') || '';
      const handle = href.split('/products/')[1]?.split(/[/?#]/)[0];
      if (handle && list.includes(handle)) btn.classList.add('saved');
    });
  }
  refreshWishlistBadges();

  // ============================================================
  // Cart discount code box — whf-fix-20260717
  // Shopify applies discount codes ONLY at checkout; the cart never sees them.
  // So we can't show a discounted subtotal here (that's a Shopify limit, not a bug).
  // What we CAN do is stop lying about it: verify the code exists, say so plainly,
  // and hand a good code to checkout where Shopify really applies it.
  // Delegated on document because rerenderCartDrawer() replaces the drawer markup.
  // ============================================================
  // Shopify checkout is the source of truth for discount eligibility.
  // Do not block customers based on a separate validation service.
  function discountMsg(text, tone) {
    const el = document.querySelector('[data-discount-msg]');
    if (!el) return;
    if (!text) { el.style.display = 'none'; el.textContent = ''; return; }
    el.textContent = text;
    el.style.display = 'block';
    el.style.color = tone === 'error' ? 'hsl(0 65% 42%)' : 'hsl(140 55% 26%)';
  }

  function goToCheckoutWithCode(code) {
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  }

  function applyDiscountCode() {
    const input = document.querySelector('[data-discount-input]');
    const btn = document.querySelector('[data-discount-apply]');
    if (!input || !btn || btn.disabled) return;
    const code = input.value.trim();
    if (!code) { discountMsg('Enter a code first.', 'error'); input.focus(); return; }
    btn.disabled = true;
    btn.textContent = 'Opening checkout…';
    discountMsg('Checking discount eligibility at checkout…', 'ok');
    goToCheckoutWithCode(code);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest && e.target.closest('[data-discount-apply]')) applyDiscountCode();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-discount-input]')) {
      e.preventDefault();
      applyDiscountCode();
    }
  });

})();

(function () {
  function initGalleryCarousels() {
    document.querySelectorAll('[data-whf-gallery-carousel]').forEach(function (wrap) {
      if (wrap.dataset.whfGalleryReady) return;
      wrap.dataset.whfGalleryReady = 'true';
      var track = wrap.querySelector('[data-gallery-thumbs-wrap]');
      var prev = wrap.querySelector('[data-whf-gallery-prev]');
      var next = wrap.querySelector('[data-whf-gallery-next]');
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      }
      function step(direction) {
        track.scrollBy({left: direction * Math.max(72, track.clientWidth * .8), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      track.addEventListener('scroll', update, {passive: true});
      track.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          step(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      new ResizeObserver(update).observe(track);
      new MutationObserver(function () {
        var active = track.querySelector('.product-gallery-thumb.active');
        if (active) {
          var item = active.getBoundingClientRect();
          var bounds = track.getBoundingClientRect();
          if (item.left < bounds.left) track.scrollLeft -= bounds.left - item.left;
          else if (item.right > bounds.right) track.scrollLeft += item.right - bounds.right;
        }
        update();
      }).observe(track, {subtree: true, attributes: true, attributeFilter: ['class']});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGalleryCarousels);
  else initGalleryCarousels();
  document.addEventListener('shopify:section:load', initGalleryCarousels);
})();
